module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.eot
// module id = 681
// module chunks = 0